import { jsx as _jsx } from "react/jsx-runtime";
import { useFeatureGuides } from './FeatureGuides';
import { useLayoutEffect, useRef } from 'react';
import { mountCaptureToolbar } from './captureToolbarDom';
/** React adapter for the same DOM renderer used by guest review. */
export function CaptureToolbar(props) {
    const featureGuides = useFeatureGuides();
    props = { ...props, featureGuides: props.featureGuides ?? featureGuides };
    const host = useRef(null);
    const instance = useRef();
    const latest = useRef(props);
    latest.current = props;
    useLayoutEffect(() => {
        instance.current = mountCaptureToolbar(host.current, latest.current);
        return () => { instance.current?.destroy(); instance.current = undefined; };
    }, []);
    useLayoutEffect(() => { instance.current?.update(props); });
    return _jsx("div", { ref: host, style: { display: 'contents' } });
}
//# sourceMappingURL=CaptureToolbar.js.map